"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPusherKey = exports.PUSHER_CLUSTERS = exports.PUSHER_KEYS = exports.WEBSOCKET_CONNECTION_TEST_URLS = exports.getIframelyApiKeyHash = exports.IFRAMELY_API_KEY_HASHES = exports.SUPPORT_URLS = exports.SUPPORTED_MOBILE_BROWSERS = exports.SUPPORTED_DESKTOP_BROWSERS = exports.getOpentokPrecallApiKey = exports.OPENTOK_PRECALL_API_KEYS = exports.getAppStoreAmplitudeApiKey = exports.APP_STORE_AMPLITUDE_API_KEYS = exports.SENTRY_DSNS = exports.getSegmentWriteKey = exports.SEGMENT_WRITE_KEYS = exports.setLaunchDarklyClientId = exports.getLaunchDarklyClientId = exports.LAUNCH_DARKLY_CLIENT_IDS = exports.getDatadogClientToken = exports.DATADOG_CLIENT_TOKENS = exports.DATADOG_RUM_KEYS = exports.getCloudfrontDistribution = exports.CLOUDFRONT_DISTRIBUTIONS = exports.getCdnBucket = exports.CDN_BUCKETS = exports.getCdnDomain = exports.CDN_DOMAINS = exports.getHopinGraphqlUrl = exports.HOPIN_GRAPHQL_URLS = exports.getHopinExploreUrl = exports.HOPIN_EXPLORE_URLS = exports.getHopinLoginUrl = exports.loginUrlsGetter = exports.setHopinSSOApiRoot = exports.getHopinSSOApiRoot = exports.ssoApiRootGetter = exports.setHopinAnalyticsRoot = exports.getHopinAnalyticsRoot = exports.HOPIN_ANALYTICS_ROOT = exports.setHopinRoot = exports.getHopinRoot = exports.rootGetter = exports.setHopinApiRoot = exports.getHopinApiRoot = exports.apiRootGetter = exports.SLICE_URL_SCHEMES = exports.getSameOriginWithoutAppSuffix = exports.isCanaryAppEnv = exports.isDevAppEnv = void 0;
exports.getLinkedinClientId = exports.LINKEDIN_CLIENT_ID = exports.getOnsiteApiUrl = exports.ONSITE_API_URLS = exports.getPusherConfig = exports.setPusherFetchCredentials = exports.getPusherFetchCredentials = exports.setPusherAuthEndpoint = exports.getPusherAuthEndpoint = exports.setPusherCluster = exports.getPusherCluster = exports.setPusherKey = void 0;
var tslib_1 = require("tslib");
var get_commit_hash_1 = require("./lib/get-commit-hash");
var get_env_var_1 = require("./lib/get-env-var");
var window_1 = require("./lib/window");
tslib_1.__exportStar(require("./lib/get-env-var"), exports);
var isDevAppEnv = function () {
    return !!(window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.location.host.match(/.*\.(ev-dev|dev)\.hopininternal\.com/));
};
exports.isDevAppEnv = isDevAppEnv;
var isCanaryAppEnv = function () {
    return (window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.location.host) ===
        'slices-dev.static.events.ringcentral.com';
};
exports.isCanaryAppEnv = isCanaryAppEnv;
var getSameOriginWithoutAppSuffix = function () {
    var _a;
    var removeHopinWebDomain = (_a = window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.location.origin.replace('.static-app.', '.')) !== null && _a !== void 0 ? _a : '';
    var removeRegistrationDomain = removeHopinWebDomain.replace('-registration.', '.');
    return removeRegistrationDomain !== null && removeRegistrationDomain !== void 0 ? removeRegistrationDomain : '';
};
exports.getSameOriginWithoutAppSuffix = getSameOriginWithoutAppSuffix;
var SLICE_URL_SCHEMES = function (_a) {
    var type = _a.type, name = _a.name, version = _a.version;
    return ({
        production: "/".concat(type, "/").concat(name, "/").concat(version, "/"),
        canary: "/".concat(type, "/").concat(name, "/").concat((0, get_commit_hash_1.getCommitHash)(), "/"),
        development: "/assets/".concat(type, "/").concat(name, "/"),
    });
};
exports.SLICE_URL_SCHEMES = SLICE_URL_SCHEMES;
var apiRootGetter = function () {
    var environment = (0, get_env_var_1.getEnvironment)();
    switch (environment) {
        case 'production':
            return 'https://events.ringcentral.com/api';
        case 'canary':
            return 'https://staging.events.ringcentral.com/api';
        case 'development':
            return 'http://localhost:3000/api';
    }
};
exports.apiRootGetter = apiRootGetter;
var getHopinApiRoot = function (version) {
    if (version === void 0) { version = 'v2'; }
    return "".concat((0, get_env_var_1.getEnvVarWithOverride)(function () {
        if ((0, exports.isDevAppEnv)()) {
            return "".concat((0, exports.getSameOriginWithoutAppSuffix)(), "/api");
        }
        return (0, get_env_var_1.getEnvVar)(exports.apiRootGetter);
    }, 'hopinApiRoot'), "/").concat(version);
};
exports.getHopinApiRoot = getHopinApiRoot;
exports.setHopinApiRoot = (0, get_env_var_1.createOverrideEnvVar)('hopinApiRoot');
var rootGetter = function () {
    var environment = (0, get_env_var_1.getEnvironment)();
    switch (environment) {
        case 'production':
            return 'https://events.ringcentral.com';
        case 'canary':
            return 'https://staging.events.ringcentral.com';
        case 'development':
            return 'http://localhost:3000';
    }
};
exports.rootGetter = rootGetter;
exports.getHopinRoot = (_a = (0, get_env_var_1.createEnvVarWithOverride)(function () {
    var _a;
    if (typeof process !== 'undefined' && ((_a = process.env) === null || _a === void 0 ? void 0 : _a.HOPIN_ROOT))
        return process.env.HOPIN_ROOT;
    if ((0, exports.isDevAppEnv)()) {
        return (0, exports.getSameOriginWithoutAppSuffix)();
    }
    return (0, get_env_var_1.getEnvVar)(exports.rootGetter);
}, 'hopinRoot'), _a.get), exports.setHopinRoot = _a.set;
exports.HOPIN_ANALYTICS_ROOT = {
    production: 'https://analytics.events.ringcentral.com',
    canary: 'https://analytics.staging.events.ringcentral.com',
    development: 'http://localhost:9292',
};
exports.getHopinAnalyticsRoot = (_b = (0, get_env_var_1.createEnvVarWithOverride)(exports.HOPIN_ANALYTICS_ROOT, 'hopinAnalyticsRoot'), _b.get), exports.setHopinAnalyticsRoot = _b.set;
var ssoApiRootGetter = function () {
    var environment = (0, get_env_var_1.getEnvironment)();
    switch (environment) {
        case 'production':
            return 'https://events.ringcentral.com';
        case 'canary':
            return 'https://staging.events.ringcentral.com';
        case 'development':
            return 'http://localhost:3000';
    }
};
exports.ssoApiRootGetter = ssoApiRootGetter;
var _c = (0, get_env_var_1.createEnvVarWithOverride)(function () {
    var _a;
    if (typeof process !== 'undefined' && ((_a = process.env) === null || _a === void 0 ? void 0 : _a.HOPIN_SSO_API_ROOT))
        return process.env.HOPIN_SSO_API_ROOT;
    if ((0, exports.isDevAppEnv)()) {
        return (0, exports.getSameOriginWithoutAppSuffix)();
    }
    return (0, get_env_var_1.getEnvVar)(exports.ssoApiRootGetter);
}, 'hopinSSOApiRoot'), getHopinSSOApiRoot = _c.get, setHopinSSOApiRoot = _c.set;
exports.getHopinSSOApiRoot = getHopinSSOApiRoot;
exports.setHopinSSOApiRoot = setHopinSSOApiRoot;
var loginUrlsGetter = function () {
    var environment = (0, get_env_var_1.getEnvironment)();
    switch (environment) {
        case 'production':
            return 'https://events.ringcentral.com/sign_in';
        case 'canary':
            return 'https://staging.events.ringcentral.com/sign_in';
        case 'development':
            return 'https://staging.events.ringcentral.com/sign_in';
    }
};
exports.loginUrlsGetter = loginUrlsGetter;
exports.getHopinLoginUrl = (0, get_env_var_1.createGetEnvVarWithOverride)(exports.loginUrlsGetter, 'hopinLoginUrl');
/**
 * @deprecated will be removed in future version
 */
exports.HOPIN_EXPLORE_URLS = {
    production: 'https://events.ringcentral.com/explore',
    canary: 'https://staging.events.ringcentral.com/explore',
    development: 'https://staging.events.ringcentral.com/explore',
};
/**
 * @deprecated will be removed in future version
 */
exports.getHopinExploreUrl = (0, get_env_var_1.createGetEnvVarWithOverride)(exports.HOPIN_EXPLORE_URLS, 'hopinExploreUrl');
exports.HOPIN_GRAPHQL_URLS = {
    production: 'https://graphql.events.ringcentral.com',
    canary: 'https://graphql.staging.events.ringcentral.com',
    development: 'https://graphql.staging.events.ringcentral.com',
};
exports.getHopinGraphqlUrl = (0, get_env_var_1.createGetEnvVarWithOverride)(exports.HOPIN_GRAPHQL_URLS, 'hopinGraphqlUrl');
exports.CDN_DOMAINS = {
    production: 'https://slices.static.events.ringcentral.com',
    canary: 'https://slices-dev.static.events.ringcentral.com',
    development: 'https://localhost:5000',
};
exports.getCdnDomain = (0, get_env_var_1.createGetEnvVarWithOverride)(exports.CDN_DOMAINS, 'cdnDomain');
exports.CDN_BUCKETS = {
    production: 'hopin-prod-slices-assets',
    canary: 'hopin-dev-slices-assets',
    development: 'none',
};
exports.getCdnBucket = (0, get_env_var_1.createGetEnvVarWithOverride)(exports.CDN_BUCKETS, 'cdnBucket');
exports.CLOUDFRONT_DISTRIBUTIONS = {
    production: 'EBQ467218WG60',
    canary: 'E1R6VVBF7HL4GP',
    development: 'none',
};
exports.getCloudfrontDistribution = (0, get_env_var_1.createGetEnvVarWithOverride)(exports.CLOUDFRONT_DISTRIBUTIONS, 'cloudfrontDistribution');
exports.DATADOG_RUM_KEYS = {
    EVENT_REPORTS: {
        clientToken: {
            production: 'pubb1780854f67cbe5a8f7de4ae10538cec',
            staging: 'pubb1780854f67cbe5a8f7de4ae10538cec',
            development: 'XXXXXX', // dummy value
        },
        applicationId: {
            production: '6cf34143-9844-46fc-a187-85e0abe8f0d2',
            staging: '6cf34143-9844-46fc-a187-85e0abe8f0d2',
            development: 'XXXXXX', // dummy value
        },
    },
};
exports.DATADOG_CLIENT_TOKENS = {
    PRECALL_TEST: {
        production: 'pube46465a7c1c453afd6fa0bb073a6dba0',
        canary: 'pub41b212202c7298d767e03ebf7788d381',
        development: 'pub0d3cfcf5343a2cbf4984341d50f76b04',
    },
    HELP_CENTER_ORGANIZER: {
        production: 'pub407fb8ef2407e065ebdbeb10fc37e2a6',
        canary: 'pub65d7f59dd6338163c9dfeb6715109346',
        development: 'pubaf34560a7fb7554133d6e84794deb0dc',
    },
};
var getDatadogClientToken = function (key) { return (0, get_env_var_1.getEnvVarWithOverride)(exports.DATADOG_CLIENT_TOKENS[key], 'datadogClientToken'); };
exports.getDatadogClientToken = getDatadogClientToken;
exports.LAUNCH_DARKLY_CLIENT_IDS = {
    production: '5eb04cd71ae17a0a740ecc57',
    canary: '5eb41a81e178470acdd2ca11',
    development: '5eb04cd71ae17a0a740ecc56',
    integration: '5fc62f9b114d4d09881ae6f1', // review apps and integration project
};
var _d = (0, get_env_var_1.createEnvVarWithOverride)(function () {
    if ((0, exports.isDevAppEnv)()) {
        return exports.LAUNCH_DARKLY_CLIENT_IDS.integration;
    }
    if ((0, exports.isCanaryAppEnv)()) {
        return exports.LAUNCH_DARKLY_CLIENT_IDS.canary;
    }
    return (0, get_env_var_1.getEnvVar)(exports.LAUNCH_DARKLY_CLIENT_IDS);
}, 'launchDarklyClientId'), getLaunchDarklyClientId = _d.get, setLaunchDarklyClientId = _d.set;
exports.getLaunchDarklyClientId = getLaunchDarklyClientId;
exports.setLaunchDarklyClientId = setLaunchDarklyClientId;
exports.SEGMENT_WRITE_KEYS = {
    production: 'EajF6DKepjOS0OalnKw2n0HQEy0b1D4M',
    canary: 'f251DXqkFXqbQf4GMq89okFL75grXoGB',
    development: 'nBSKPC0tMkz010ZDvUvGPkRNLygAaDN2',
};
exports.getSegmentWriteKey = (0, get_env_var_1.createGetEnvVarWithOverride)(exports.SEGMENT_WRITE_KEYS, 'segmentWriteKey');
exports.SENTRY_DSNS = {
    ANALYTICS_REGISTRATION_DASHBOARD: 'https://4bdd992f5c6f4d56888d391a17626450@o370914.ingest.sentry.io/6677096',
    EVENT_APPS: 'https://c51aa1c1ed6e48c689987f27b37842d5@o370914.ingest.sentry.io/6220426',
    EVENT_REPORTS: 'https://c769ae5389bc4da1b1d83739068a967b@o370914.ingest.sentry.io/4504084362100736',
    PRECALL_TEST: 'https://aec5a42c15004673b0691794293f5f98@o370914.ingest.sentry.io/5885122',
    ONSITE_BADGE_DESIGNER: 'https://344ce605efed4648aa5be098a6463014@o370914.ingest.sentry.io/5910763',
    ONSITE_CHECKIN_AREA: 'https://f6f4adbc1d1b424691882c067ae7f67a@o370914.ingest.sentry.io/5910759',
    ONSITE_KIOSK_MODE: 'https://fdbb29281c12454f964c67dba97f2672@o370914.ingest.sentry.io/5910762',
    ONSITE_FLOOR_PLANS: 'https://becb5ccd48484cc4b9b7bc3b5db43b57@o370914.ingest.sentry.io/6248746',
    ONSITE_SIGNATURES: 'https://1f1a0e679f5d4ae7a3870aae9432b660@o370914.ingest.sentry.io/6508850',
    EXPO_BOOTH: 'https://dbb6cfd8e74d4a7394eae539cb33a354@o370914.ingest.sentry.io/5973303',
    RECEPTION: 'https://68ee51647cdc4e17a22ea82649f5f514@o370914.ingest.sentry.io/5834021',
    SCHEDULES_RECEPTION_VIEW: 'https://f0dd14bd6cc14a6c94fb68c0c0c5d2f4@o370914.ingest.sentry.io/6068627',
    SCHEDULES_ORGANISER: 'https://8b29d9fb748049ebbd3a0f30582f6531@o370914.ingest.sentry.io/5756450',
    SCHEDULES_PUBLIC: 'https://3f2c234d4a584ef5ba155027deafbf0a@o370914.ingest.sentry.io/5795641',
    SCHEDULES_INEVENT: 'https://34d4d0de1f9740acbb6ea84e14478acf@o370914.ingest.sentry.io/6432845',
    HELP_CENTER_ORGANIZER: 'https://1f5b2e2cd6754950929fdbe643449c82@o370914.ingest.sentry.io/4504000478576640',
};
// This is for app-store-slice. After App Store v4 is released, we will remove this.
exports.APP_STORE_AMPLITUDE_API_KEYS = {
    production: '865d4e30afeaec50b81830c5cf65d729',
    canary: '572413ce49b46781c11904437236cd6d',
    development: '421371dec1c44802df34bfe82c81e5ba',
};
exports.getAppStoreAmplitudeApiKey = (0, get_env_var_1.createGetEnvVarWithOverride)(exports.APP_STORE_AMPLITUDE_API_KEYS, 'appStoreAmplitudeApiKey');
exports.OPENTOK_PRECALL_API_KEYS = {
    production: '46934894',
    canary: '46932154',
    development: '46932154',
};
exports.getOpentokPrecallApiKey = (0, get_env_var_1.createGetEnvVarWithOverride)(exports.OPENTOK_PRECALL_API_KEYS, 'opentokPrecallApiKey');
exports.SUPPORTED_DESKTOP_BROWSERS = [
    {
        os: 'Windows',
        os_version: '10',
        browser: 'Chrome',
        browser_version: '86.0',
    },
    {
        os: 'Windows',
        os_version: '10',
        browser: 'Edge',
        browser_version: '87.0',
    },
    {
        os: 'Windows',
        os_version: '10',
        browser: 'Firefox',
        browser_version: '82.0',
    },
    {
        os: 'OS X',
        os_version: 'Catalina',
        browser: 'Safari',
        browser_version: '13.1',
    },
];
exports.SUPPORTED_MOBILE_BROWSERS = [
    {
        os: 'iOS',
        os_version: '13.0',
        device_browser: 'Safari',
    },
    {
        os: 'Android',
        os_version: '11.0',
        device: 'Google Pixel 4',
        device_browser: 'Chrome',
    },
    {
        os: 'Android',
        os_version: '11.0',
        device: 'Google Pixel 4',
        device_browser: 'Firefox',
    },
    {
        os: 'Android',
        os_version: '11.0',
        device: 'Samsung Galaxy S20',
        device_browser: 'Samsung',
    },
];
exports.SUPPORT_URLS = {
    browser_compatibility: 'https://hopin.zendesk.com/hc/en-gb/articles/360056078872',
    media_devices_mac: 'https://hopin.zendesk.com/hc/en-gb/articles/360056527911',
    media_devices_windows: 'https://hopin.zendesk.com/hc/en-gb/articles/360059277232-I-m-having-Camera-and-or-Microphone-issues-on-Windows-10',
    network_connectivity_settings: 'https://hopin.zendesk.com/hc/en-gb/articles/360056528911',
    prepare_for_event: 'https://hopin.zendesk.com/hc/en-gb/articles/4401838325652',
    tech_specifications: 'https://hopin.zendesk.com/hc/en-gb/articles/360062330691',
};
exports.IFRAMELY_API_KEY_HASHES = {
    production: 'c774bf49ce1c1a1bb2e4d5ff548520aa',
    canary: 'c774bf49ce1c1a1bb2e4d5ff548520aa',
    development: '2b80229b747e26de2e9b41fe9bc26298',
};
exports.getIframelyApiKeyHash = (0, get_env_var_1.createGetEnvVarWithOverride)(exports.IFRAMELY_API_KEY_HASHES, 'iframelyApiKeyHash');
exports.WEBSOCKET_CONNECTION_TEST_URLS = {
    getstream: 'wss://hopin-chat-dublin.stream-io-api.com/connect',
    hopinlive: 'wss://prod.live.hopin.to/connect/test',
    pusher: 'wss://ws-eu.pusher.com',
};
exports.PUSHER_KEYS = {
    production: 'd9b03d485c6d62190e94',
    canary: '00f26110e245c71efda3',
    development: 'abcdef',
    integration: '00f26110e245c71efda3',
};
exports.PUSHER_CLUSTERS = {
    production: 'eu',
    canary: 'eu',
    development: 'eu',
    integration: 'eu',
};
var _e = (0, get_env_var_1.createEnvVarWithOverride)(function () {
    if ((0, exports.isDevAppEnv)()) {
        return exports.PUSHER_KEYS.integration;
    }
    return (0, get_env_var_1.getEnvVar)(exports.PUSHER_KEYS);
}, 'pusherKey'), getPusherKey = _e.get, setPusherKey = _e.set;
exports.getPusherKey = getPusherKey;
exports.setPusherKey = setPusherKey;
var _f = (0, get_env_var_1.createEnvVarWithOverride)(function () {
    if ((0, exports.isDevAppEnv)()) {
        return exports.PUSHER_CLUSTERS.integration;
    }
    return (0, get_env_var_1.getEnvVar)(exports.PUSHER_CLUSTERS);
}, 'pusherCluster'), getPusherCluster = _f.get, setPusherCluster = _f.set;
exports.getPusherCluster = getPusherCluster;
exports.setPusherCluster = setPusherCluster;
var _g = (0, get_env_var_1.createEnvVarWithOverride)(function () {
    if ((0, exports.isDevAppEnv)()) {
        return "".concat((0, exports.getSameOriginWithoutAppSuffix)(), "/api/v2/pusher/auth");
    }
    return "".concat((0, exports.getHopinApiRoot)('v2'), "/pusher/auth");
}, 'pusherAuthEndpoint'), getPusherAuthEndpoint = _g.get, setPusherAuthEndpoint = _g.set;
exports.getPusherAuthEndpoint = getPusherAuthEndpoint;
exports.setPusherAuthEndpoint = setPusherAuthEndpoint;
var _h = (0, get_env_var_1.createEnvVarWithOverride)(function () {
    var _a;
    if (typeof process !== 'undefined' && ((_a = process.env) === null || _a === void 0 ? void 0 : _a.PUSHER_FETCH_CREDENTIALS))
        return process.env.PUSHER_FETCH_CREDENTIALS;
    return 'true';
}, 'pusherFetchCredentials'), getPusherFetchCredentials = _h.get, setPusherFetchCredentials = _h.set;
exports.getPusherFetchCredentials = getPusherFetchCredentials;
exports.setPusherFetchCredentials = setPusherFetchCredentials;
var getPusherConfig = function () { return ({
    key: getPusherKey(),
    cluster: getPusherCluster(),
    auth_endpoint: getPusherAuthEndpoint(),
    fetch_credentials: getPusherFetchCredentials(),
}); };
exports.getPusherConfig = getPusherConfig;
exports.ONSITE_API_URLS = {
    production: 'https://onsite-api.events.ringcentral.com',
    canary: 'https://onsite-api.staging.events.ringcentral.com',
    development: 'https://onsite-api.staging.events.ringcentral.com',
};
exports.getOnsiteApiUrl = (0, get_env_var_1.createGetEnvVarWithOverride)(exports.ONSITE_API_URLS, 'onsiteApiUrl');
exports.LINKEDIN_CLIENT_ID = {
    production: '779ulxchaot71f',
    canary: '7735hzievvupsv',
    development: '77irk67914b01d',
};
exports.getLinkedinClientId = (0, get_env_var_1.createGetEnvVarWithOverride)(exports.LINKEDIN_CLIENT_ID, 'linkedinClientId');
//# sourceMappingURL=index.js.map